import { Status } from 'services/api/api-client';
import { NodeType } from 'helpers/documents/types/base';
import { FolderStatus } from 'helpers/documents/types/documents';
import { StatusItem } from '../../statuses/statusItem/StatusItem.tsx';
import { StatusItemType } from '../../statuses/statusItem/stauts-item-type.ts';
import { TreeItemColumn } from './TreeItemColumn.tsx';

type TreeItemStatusColumnProps = {
  hiddenColumns: string[];
  itemType: NodeType;
  status: Status | FolderStatus;
  disabled: boolean;
  statusAnchorRef?: any;
  onClick?: () => void;
};

/** Status column for a tree item. */
export const TreeItemStatusColumn = ({
  hiddenColumns,
  itemType,
  status,
  disabled,
  statusAnchorRef,
  onClick,
}: TreeItemStatusColumnProps) => (
  <TreeItemColumn column="status" hiddenColumns={hiddenColumns}>
    <StatusItem
      isFilter={false}
      buttonType={StatusItemType.DefaultButton}
      itemType={itemType}
      itemStatus={status}
      disabled={disabled}
      onClick={onClick ?? (() => {})}
      statusAnchorRef={statusAnchorRef}
    />
  </TreeItemColumn>
);
